// src/api/axios.js
import axios from "axios";

const api = axios.create({
  baseURL: "https://elwasitelkadai.com/api",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// قبل كل طلب، أضف التوكن لو موجود
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
